/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tea_Grade_TotalInputs */

const vi_tea_grade_total = /** @type {(inputs: Tea_Grade_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng: ${i?.count} phân loại`)
};

/**

* @param {Tea_Grade_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_total = /** @type {((inputs: Tea_Grade_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_total(inputs)
});